export let TypeStream;

(function (TypeStream) {
  TypeStream["ReqStreamSubscribe"] = "REQ.STREAM.SUBSCRIBE";
  TypeStream["ReqStreamEmit"] = "REQ.STREAM.EMIT";
  TypeStream["ResStreamEvent"] = "RES.STREAM.EVENT";
})(TypeStream || (TypeStream = {}));